import React, { forwardRef } from "react";

import { format } from "date-fns";

import {
  Box,
  Flex,
  Spacer,
  Text,
  HStack,
  Stack,
  List,
  ListItem,
  SimpleGrid,
} from "@chakra-ui/react";
import logoMCA from "../../../img-docs/logomca.png";

import { IrmaoTable } from "../../pages/Criancas/ReferenciaFamiliar/Irmaos/Table";
import SemRegistros from "../SemRegistros";
import { RiPushpinLine } from "react-icons/ri";
import { dashboardFunc } from "../../../helpers/Funcionalidades";

export const ComponentToPrintRelatorioServico = forwardRef((props, ref) => {
  const renderSN = (value) => {
    if (!value || value.length === 0) return "";

    const hasS = value.includes("S");
    const hasN = value.includes("N");

    if (hasS && hasN) return " Sim e Não";
    if (hasS) return " Sim";
    if (hasN) return " Não";

    return "";
  };

  return (
    <Box display="block" ref={ref}>
      <table style={{ width: props?.dataPendencias?.length <= 0 && "100%" }}>
        <thead>
          <tr>
            <td>
              {/* Header Spacer */}
              <Box height="100px" />
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <Box display="break-page">
                <Stack alignItems="center" px={10}>
                  <Text fontSize={"3xl"} fontWeight={700} color="#6A6A6A">
                    Relatório Serviço de Acolhimento
                  </Text>
                  <Text>{""}</Text>

                  {props?.dataPendencias?.length > 0 ? (
                    <Box display={"block"}>
                      <IrmaoTable
                        mt={"0px"}
                        columns={props.columnsPendencias}
                        data={props.dataPendencias}
                        entidade="relatorio-servico-acolhimento"
                        disableHeaderOptions={true}
                        isPrint={true}
                      />
                      <Text mt={4}>
                        Total de Registro(s): {props?.storage?.totalItems ?? 0}
                      </Text>
                    </Box>
                  ) : (
                    <Box w={"full"} display={"block"}>
                      <SemRegistros buttonVisible={true} half />
                    </Box>
                  )}
                </Stack>
                <Box px={10} py={20}>
                  <Text
                    fontSize={"3xl"}
                    fontWeight={700}
                    color="#6A6A6A"
                    textAlign={"center"}
                  >
                    Filtros Preenchidos
                  </Text>
                  <Text>{""}</Text>
                  <Flex
                    borderRadius="12px"
                    boxShadow="0px 24px 40px 0px #00000014"
                    border="1px solid #00000014"
                    p={10}
                    mt={4}
                  >
                    <Text
                      borderBottom="3px solid #169499"
                      as="b"
                      pb={2}
                      fontSize={"18px"}
                      display="flex"
                      alignItems="center"
                      gap={2}
                      mr={2}
                    >
                      <RiPushpinLine size={20} />
                      Status:
                      <Text fontWeight={"normal"}>
                        {props?.storage?.statusRelatorio
                          ?.map(
                            (item) =>
                              ({
                                A: "Ativo",
                                S: "Suspenso",
                                D: "Desativado",
                              })[item],
                          )
                          .join(", ")}
                      </Text>
                    </Text>
                  </Flex>
                  <Flex
                    direction="column"
                    borderRadius="12px"
                    boxShadow="0px 24px 40px 0px #00000014"
                    border="1px solid #00000014"
                    mt={4}
                    p={10}
                  >
                    <Box display="break-page">
                      <Text
                        borderBottom="3px solid #169499"
                        pb={2}
                        as="b"
                        fontSize={"18px"}
                        display="inline-flex"
                        alignItems="center"
                        gap={2}
                        mr={2}
                        w="fit-content"
                      >
                        <RiPushpinLine size={20} />
                        Localização do Serviço de Acolhimento
                      </Text>
                      <SimpleGrid columns={4} spacingY={3} w="100%" mt={10}>
                        {/* HEADER */}
                        <Text fontWeight="bold" color="#169499">
                          Estado
                        </Text>
                        <Text fontWeight="bold" color="#169499">
                          Município
                        </Text>
                        <Text fontWeight="bold" color="#169499">
                          Bairro
                        </Text>
                        <Text fontWeight="bold" color="#169499">
                          Nome do Serviço de Acolhimento
                        </Text>

                        {/* LINHA ÚNICA */}
                        <Text>
                          {props?.storage?.idEstado?.[0]
                            ?.map((e) => e.nome)
                            .join(", ") || "Todos"}
                        </Text>

                        <Text>
                          {props?.storage?.idMunicipio?.[0]?.[0]?.descricao ===
                          "Todos"
                            ? "Todos"
                            : props?.storage?.idMunicipio?.[0]
                                ?.map((m) => m.descricao)
                                .join(", ") || "Todos"}
                        </Text>

                        <Text>
                          {props?.storage?.idBairro?.[0]?.[0]?.descricao ===
                          "Todos"
                            ? "Todos"
                            : props?.storage?.idBairro?.[0]
                                ?.map((b) => b.descricao)
                                .join(", ") || "Todos"}
                        </Text>

                        <Text>
                          {props?.storage?.idsServicosAcolhimento?.[0]
                            ?.map((e) => e.nomeFantasia)
                            .join(", ") || "Todos"}
                        </Text>
                      </SimpleGrid>
                    </Box>

                    <Box display="break-page">
                      <Text
                        borderBottom="3px solid #169499"
                        pb={2}
                        as="b"
                        fontSize={"18px"}
                        display="inline-flex"
                        alignItems="center"
                        gap={2}
                        mr={2}
                        mt={10}
                        w="fit-content"
                      >
                        <RiPushpinLine size={20} />
                        Orgãos
                      </Text>
                      {!!props?.storage?.idMunicipioOrgao &&
                        props?.storage?.idMunicipioOrgao?.length > 0 && (
                          <>
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                              mt={6}
                            >
                              Município
                            </Text>
                            <List styleType="disc" p={5}>
                              {props?.storage?.idMunicipioOrgao[0]?.map(
                                (item) => (
                                  <ListItem key={item.id}>
                                    {item.descricao}
                                  </ListItem>
                                ),
                              )}
                            </List>
                          </>
                        )}
                      {!!props?.storage?.idPromotoriaOrgaos &&
                        props?.storage?.idPromotoriaOrgaos?.length > 0 && (
                          <>
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                              mt={6}
                            >
                              Promotoria de Justiça
                            </Text>
                            <List styleType="disc" p={5}>
                              {props?.storage?.idPromotoriaOrgaos[0]?.map(
                                (item) => (
                                  <ListItem key={item.id}>
                                    {item.descricao}
                                  </ListItem>
                                ),
                              )}
                            </List>
                          </>
                        )}
                      {!!props?.storage?.idVaraOrgaos &&
                        props?.storage?.idVaraOrgaos?.length > 0 && (
                          <>
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                              mt={6}
                            >
                              Vara da Infância
                            </Text>
                            <List styleType="disc" p={5}>
                              {props?.storage?.idVaraOrgaos[0]?.map((item) => (
                                <ListItem key={item.id}>
                                  {item.descricao}
                                </ListItem>
                              ))}
                            </List>
                          </>
                        )}
                    </Box>

                    <Box display="break-page">
                      <Text
                        borderBottom="3px solid #169499"
                        pb={2}
                        as="b"
                        fontSize={"18px"}
                        display="inline-flex"
                        alignItems="center"
                        gap={2}
                        mr={2}
                        mt={10}
                        w="fit-content"
                      >
                        <RiPushpinLine size={20} />
                        Caracterização do Serviço de Acolhimento
                      </Text>
                      {(!!props?.storage?.naturezaServico ||
                        !!props?.storage?.regime ||
                        (!!props?.storage?.modalidade &&
                          props?.storage?.modalidade?.length > 0)) && (
                        <SimpleGrid columns={3} spacingY={3} w="100%" mt={10}>
                          {/* HEADER */}
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                          >
                            {!!props?.storage?.naturezaServico &&
                              "Natureza do Serviço"}
                          </Text>
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                          >
                            {!!props?.storage?.regime && "Regime"}
                          </Text>
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                          >
                            {!!props?.storage?.modalidade &&
                              props?.storage?.modalidade?.length > 0 &&
                              "Modalidade"}
                          </Text>

                          <Box>
                            {props?.storage?.naturezaServico?.[0]?.map(
                              (item) => (
                                <Text
                                  key={item.id}
                                  borderBottom="1px solid #00000014"
                                  p={1}
                                >
                                  {item.descricao}
                                </Text>
                              ),
                            )}
                          </Box>

                          <Box>
                            {props?.storage?.regime?.[0]?.map((item) => (
                              <Text
                                key={item.id}
                                borderBottom="1px solid #00000014"
                                p={1}
                              >
                                {item.descricao}
                              </Text>
                            ))}
                          </Box>

                          <Box>
                            {props?.storage?.modalidade?.[0]?.map((item) => (
                              <Text
                                key={item.id}
                                borderBottom="1px solid #00000014"
                                p={1}
                              >
                                {item.descricao}
                              </Text>
                            ))}
                          </Box>
                        </SimpleGrid>
                      )}
                    </Box>

                    <Box display="break-page">
                      <Text
                        borderBottom="3px solid #169499"
                        pb={2}
                        as="b"
                        fontSize={"18px"}
                        display="inline-flex"
                        alignItems="center"
                        gap={2}
                        mr={2}
                        mt={10}
                        w="fit-content"
                      >
                        <RiPushpinLine size={20} />
                        Perfil de Atendimento
                      </Text>
                      {((!!props?.storage?.idGenero &&
                        props?.storage?.idGenero?.length > 0) ||
                        !!props?.storage?.radioGenero) && (
                        <SimpleGrid columns={3} spacingY={3} w="100%" mt={10}>
                          {/* HEADER */}
                          <>
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                            >
                              Gênero
                            </Text>
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                            />
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                            />
                          </>

                          {!!props?.storage?.radioGenero && (
                            <Text p={1}>
                              {props?.storage?.radioGenero === "SR"
                                ? "Sem Restrição"
                                : props?.storage?.radioGenero === "AS"
                                  ? "Atende Somente"
                                  : props?.storage?.radioGenero === "NA"
                                    ? "Não Atende"
                                    : ""}
                            </Text>
                          )}

                          {!!props?.storage?.idGenero &&
                            props?.storage?.idGenero?.length > 0 && (
                              <Text p={1}>
                                Gênero:{" "}
                                {props?.storage?.idGenero?.[0]
                                  ?.map((item) => item.genero)
                                  .join(", ")}
                              </Text>
                            )}
                        </SimpleGrid>
                      )}
                      {(!!props?.storage?.radioFaixaEtaria ||
                        !!props?.storage?.idadeMinima ||
                        !!props?.Boxstorage?.idadeMaxima ||
                        !!props?.storage?.idadeInicial ||
                        !!props?.storage?.idadeFinal) && (
                        <SimpleGrid columns={3} spacingY={3} w="100%" mt={10}>
                          {/* HEADER */}
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                          >
                            Faixa Etária
                          </Text>
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                          />
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                          />

                          {!!props?.storage?.radioFaixaEtaria && (
                            <Text p={1}>
                              {props?.storage?.radioFaixaEtaria === "TO"
                                ? "Todos"
                                : props?.storage?.radioFaixaEtaria === "AT"
                                  ? "Atende"
                                  : props?.storage?.radioFaixaEtaria === "CR"
                                    ? "Com Restrição de Faixa Etária"
                                    : ""}
                            </Text>
                          )}

                          {props?.storage?.radioFaixaEtaria === "AT" && (
                            <>
                              {" "}
                              {!!props?.storage?.idadeInicial &&
                                !!props?.storage?.idadeFinal && (
                                  <Text p={1}>
                                    De {props?.storage?.idadeInicial} até{" "}
                                    {props?.storage?.idadeFinal} anos
                                  </Text>
                                )}
                            </>
                          )}

                          {props?.storage?.radioFaixaEtaria === "CR" && (
                            <>
                              {" "}
                              {!!props?.storage?.idadeMinima && (
                                <Text p={1}>
                                  Idade Mínima aceita pelo Serviço:{" "}
                                  {props?.storage?.idadeMinima}
                                </Text>
                              )}
                              {!!props?.storage?.idadeMaxima && (
                                <Text p={1}>
                                  Idade Máxima Aceita pelo Serviço:{" "}
                                  {props?.storage?.idadeMaxima}
                                </Text>
                              )}
                            </>
                          )}
                        </SimpleGrid>
                      )}
                    </Box>

                    <Box display="break-page">
                      {((props?.storage?.radioSaudeCriancaDeficiencia?.length ??
                        0) > 0 ||
                        (props?.storage?.radioSaudeSubstanciasPsicoativas
                          ?.length ?? 0) > 0 ||
                        (props?.storage?.radioSaudeCriancaCuidados?.length ??
                          0) > 0) && (
                        <SimpleGrid columns={3} spacingY={3} w="100%" mt={10}>
                          {/* HEADER */}
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                          >
                            Saúde
                          </Text>
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                          />
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                          />

                          {(props?.storage?.radioSaudeCriancaDeficiencia
                            ?.length ?? 0) > 0 && (
                            <Text p={1}>
                              Restrição de Criança/Adolescente com Deficiência:{" "}
                              {renderSN(
                                props?.storage.radioSaudeCriancaDeficiencia,
                              )}
                            </Text>
                          )}

                          {(props?.storage?.radioSaudeSubstanciasPsicoativas
                            ?.length ?? 0) > 0 && (
                            <Text p={1}>
                              Restrição de Criança/Adolescente que faz uso de
                              substâncias psicoativas:{" "}
                              {renderSN(
                                props?.storage.radioSaudeSubstanciasPsicoativas,
                              )}
                            </Text>
                          )}

                          {(props?.storage?.radioSaudeCriancaCuidados?.length ??
                            0) > 0 && (
                            <Text p={1}>
                              Faz Restrição de Criança/Adolescente que Demanda
                              Cuidados de Saúde:{" "}
                              {renderSN(
                                props?.storage.radioSaudeCriancaCuidados,
                              )}
                            </Text>
                          )}
                        </SimpleGrid>
                      )}
                    </Box>
                    {props.roleKeycloack?.includes(
                      dashboardFunc.abasGestorDemais,
                    ) && (
                      <>
                        <Box display="break-page">
                          <Text
                            borderBottom="3px solid #169499"
                            pb={2}
                            as="b"
                            fontSize={"18px"}
                            display="inline-flex"
                            alignItems="center"
                            gap={2}
                            mr={2}
                            mt={10}
                            w="fit-content"
                          >
                            <RiPushpinLine size={20} />
                            Regularidade
                          </Text>

                          {(!!props?.storage?.registroCMDCA ||
                            !!props?.storage?.registroValidoCMDCA ||
                            !!props?.storage?.inscricaoCMDCA ||
                            !!props?.storage?.inscricaoValidaCMDCA ||
                            !!props?.storage?.inscricaoCMAS ||
                            !!props?.storage?.inscricaoValidaCMAS) && (
                            <SimpleGrid
                              columns={3}
                              spacing={3}
                              w="100%"
                              mt={10}
                            >
                              {((props?.storage?.registroCMDCA?.length ?? 0) >
                                0 ||
                                (props?.storage?.registroValidoCMDCA?.length ??
                                  0) > 0) && (
                                <Box>
                                  {(props?.storage?.registroCMDCA?.length ??
                                    0) > 0 && (
                                    <Text p={1}>
                                      Há Registro no CMDCA:
                                      {renderSN(props?.storage?.registroCMDCA)}
                                    </Text>
                                  )}

                                  {(props?.storage?.registroValidoCMDCA
                                    ?.length ?? 0) > 0 && (
                                    <Text p={1}>
                                      Há Registro Válido no CMDCA:
                                      {renderSN(
                                        props?.storage?.registroValidoCMDCA,
                                      )}
                                    </Text>
                                  )}
                                </Box>
                              )}

                              {((props?.storage?.inscricaoCMDCA?.length ?? 0) >
                                0 ||
                                (props?.storage?.inscricaoValidaCMDCA?.length ??
                                  0) > 0) && (
                                <Box>
                                  {(props?.storage?.inscricaoCMDCA?.length ??
                                    0) > 0 && (
                                    <Text p={1}>
                                      Há Inscrição no CMDCA:
                                      {renderSN(props?.storage?.inscricaoCMDCA)}
                                    </Text>
                                  )}

                                  {(props?.storage?.inscricaoValidaCMDCA
                                    ?.length ?? 0) > 0 && (
                                    <Text p={1}>
                                      Há Inscrição Válida no CMDCA:
                                      {renderSN(
                                        props?.storage?.inscricaoValidaCMDCA,
                                      )}
                                    </Text>
                                  )}
                                </Box>
                              )}

                              {((props?.storage?.inscricaoCMAS?.length ?? 0) >
                                0 ||
                                (props?.storage?.inscricaoValidaCMAS?.length ??
                                  0) > 0) && (
                                <Box>
                                  {(props?.storage?.inscricaoCMAS?.length ??
                                    0) > 0 && (
                                    <Text p={1}>
                                      Há Inscrição no CMAS:
                                      {renderSN(props?.storage?.inscricaoCMAS)}
                                    </Text>
                                  )}

                                  {(props?.storage?.inscricaoValidaCMAS
                                    ?.length ?? 0) > 0 && (
                                    <Text p={1}>
                                      HHá Inscrição Válida no CMAS:
                                      {renderSN(
                                        props?.storage?.inscricaoValidaCMAS,
                                      )}
                                    </Text>
                                  )}
                                </Box>
                              )}
                            </SimpleGrid>
                          )}
                        </Box>

                        <Box display="break-page">
                          <Text
                            borderBottom="3px solid #169499"
                            pb={2}
                            as="b"
                            fontSize={"18px"}
                            display="inline-flex"
                            alignItems="center"
                            gap={2}
                            mr={2}
                            mt={10}
                            w="fit-content"
                          >
                            <RiPushpinLine size={20} />
                            Planejamento
                          </Text>

                          {(!!props?.storage?.possuiPlano ||
                            !!props?.storage?.possuiRegimento ||
                            !!props?.storage?.possuiProjeto ||
                            !!props?.storage?.possuiRelatorio) && (
                            <SimpleGrid
                              columns={3}
                              spacing={3}
                              w="100%"
                              mt={10}
                            >
                              {((props?.storage?.possuiPlano?.length ?? 0) >
                                0 ||
                                (props?.storage?.possuiRegimento?.length ?? 0) >
                                  0) && (
                                <Box>
                                  {(props?.storage?.possuiPlano?.length ?? 0) >
                                    0 && (
                                    <Text p={1}>
                                      Possui Plano de Trabalho:
                                      {renderSN(props?.storage?.possuiPlano)}
                                    </Text>
                                  )}

                                  {(props?.storage?.possuiRegimento?.length ??
                                    0) > 0 && (
                                    <Text p={1}>
                                      Possui Regimento Interno:
                                      {renderSN(
                                        props?.storage?.possuiRegimento,
                                      )}
                                    </Text>
                                  )}
                                </Box>
                              )}

                              {(props?.storage?.possuiProjeto?.length ?? 0) >
                                0 && (
                                <Box>
                                  {(props?.storage?.possuiProjeto?.length ??
                                    0) > 0 && (
                                    <Text p={1}>
                                      Possui Projeto Político-Pedagógico:
                                      {renderSN(props?.storage?.possuiProjeto)}
                                    </Text>
                                  )}
                                </Box>
                              )}

                              {(props?.storage?.possuiRelatorio?.length ?? 0) >
                                0 && (
                                <Box>
                                  {(props?.storage?.possuiRelatorio?.length ??
                                    0) > 0 && (
                                    <Text p={1}>
                                      Possui Relatório Anual:
                                      {renderSN(
                                        props?.storage?.possuiRelatorio,
                                      )}
                                    </Text>
                                  )}
                                </Box>
                              )}
                            </SimpleGrid>
                          )}
                        </Box>
                        {!props.roleKeycloack?.includes(
                          dashboardFunc.abasDefensoriaOcultar,
                        ) && (
                          <>
                            <Box display="break-page">
                              <Text
                                borderBottom="3px solid #169499"
                                pb={2}
                                as="b"
                                fontSize={"18px"}
                                display="inline-flex"
                                alignItems="center"
                                gap={2}
                                mr={2}
                                mt={10}
                                w="fit-content"
                              >
                                <RiPushpinLine size={20} />
                                Equipe de Referência
                              </Text>

                              {(props?.storage?.possuiAcessoMCA?.length ?? 0) >
                                0 && (
                                <SimpleGrid
                                  columns={1}
                                  spacing={3}
                                  w="100%"
                                  mt={10}
                                >
                                  {(props?.storage?.possuiAcessoMCA?.length ??
                                    0) > 0 && (
                                    <Box>
                                      {(props?.storage?.possuiAcessoMCA
                                        ?.length ?? 0) > 0 && (
                                        <Text p={1}>
                                          Possui acesso ao MCA:
                                          {renderSN(
                                            props?.storage?.possuiAcessoMCA,
                                          )}
                                        </Text>
                                      )}
                                    </Box>
                                  )}
                                </SimpleGrid>
                              )}
                            </Box>

                            <Box display="break-page">
                              <Text
                                borderBottom="3px solid #169499"
                                pb={2}
                                as="b"
                                fontSize={"18px"}
                                display="inline-flex"
                                alignItems="center"
                                gap={2}
                                mr={2}
                                mt={10}
                                w="fit-content"
                              >
                                <RiPushpinLine size={20} />
                                Voluntariado
                              </Text>

                              {(props?.storage?.possuiVoluntariado?.length ??
                                0) > 0 && (
                                <SimpleGrid
                                  columns={1}
                                  spacing={3}
                                  w="100%"
                                  mt={10}
                                >
                                  {(props?.storage?.possuiVoluntariado
                                    ?.length ?? 0) > 0 && (
                                    <Box>
                                      {(props?.storage?.possuiVoluntariado
                                        ?.length ?? 0) > 0 && (
                                        <Text p={1}>
                                          O Serviço de Acolhimento possui
                                          voluntariado:
                                          {renderSN(
                                            props?.storage?.possuiVoluntariado,
                                          )}
                                        </Text>
                                      )}
                                    </Box>
                                  )}
                                </SimpleGrid>
                              )}
                            </Box>
                          </>
                        )}

                        <Box display="break-page">
                          <Text
                            borderBottom="3px solid #169499"
                            pb={2}
                            as="b"
                            fontSize={"18px"}
                            display="inline-flex"
                            alignItems="center"
                            gap={2}
                            mr={2}
                            mt={10}
                            w="fit-content"
                          >
                            <RiPushpinLine size={20} />
                            Programa de Apadrinhamento
                          </Text>

                          {!!props?.storage?.mantemPrograma && (
                            <SimpleGrid
                              columns={2}
                              spacing={3}
                              w="100%"
                              mt={10}
                            >
                              {(props?.storage?.mantemPrograma?.length ?? 0) >
                                0 && (
                                <Box>
                                  {(props?.storage?.mantemPrograma?.length ??
                                    0) > 0 && (
                                    <Text p={1}>
                                      O Serviço de Acolhimento mantém Programa
                                      de Apadrinhamento:
                                      {renderSN(props?.storage?.mantemPrograma)}
                                    </Text>
                                  )}
                                </Box>
                              )}

                              {(props?.storage?.encontraInscritoCMDCA?.length ??
                                0) > 0 && (
                                <Box>
                                  {(props?.storage?.encontraInscritoCMDCA
                                    ?.length ?? 0) > 0 && (
                                    <Text p={1}>
                                      Em caso Positivo, esse Programa se
                                      encontra Inscrito no CMDCA:
                                      {renderSN(
                                        props?.storage?.encontraInscritoCMDCA,
                                      )}
                                    </Text>
                                  )}
                                </Box>
                              )}
                            </SimpleGrid>
                          )}
                        </Box>
                      </>
                    )}

                    <Box display="break-page">
                      <Text
                        borderBottom="3px solid #169499"
                        pb={2}
                        as="b"
                        fontSize={"18px"}
                        display="inline-flex"
                        alignItems="center"
                        gap={2}
                        mr={2}
                        mt={10}
                        w="fit-content"
                      >
                        <RiPushpinLine size={20} />
                        Vagas Disponíveis
                      </Text>
                      {!!props?.storage?.possuiVaga && (
                        <Text mt={6}>
                          Possui Vagas Disponíveis:{" "}
                          {props?.storage?.possuiVaga === "S" ? "Sim" : "Não"}
                        </Text>
                      )}
                    </Box>
                  </Flex>
                </Box>
              </Box>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>
              {/* Footer Spacer */}
              <Box height="150px" />
            </td>
          </tr>
        </tfoot>
      </table>

      {/* Header */}
      <HStack
        position="fixed"
        top={0}
        pt="17.5px"
        pl={"50px"}
        pb="10px"
        alignItems="end"
        justifyContent="space-between"
        backgroundColor="#FFF"
        zIndex={100}
        width="100%"
        borderBottom="solid 1px #D1D0CF"
      >
        <img
          src={logoMCA}
          alt="LogoMCA"
          style={{ width: "200px", height: "60px" }}
        />

        <Box width="200px" />
      </HStack>
      {/* Footer */}
      <Box
        position="fixed"
        bottom={10}
        pb="17.5px"
        pt="20px"
        w="100%"
        px="15px"
        backgroundColor="#006064"
        zIndex={100}
      >
        <Text color={"#fff"}>Usuário: {props?.user?.name}</Text>
        <Text color={"#fff"}>
          Orgão: {props?.dados?.nomeOrgao || props?.dados?.nomeOrgaoExterno}
        </Text>
        <Text color={"#fff"}>{`Data da impressão: ${format(
          new Date(),
          "dd/MM/yyyy",
        )} ${format(new Date(), "HH:mm:ss")}`}</Text>
      </Box>
      <Flex
        position="fixed"
        bottom={0}
        pt="10px"
        w="100%"
        px="15px"
        backgroundColor="#FFF"
        zIndex={100}
      >
        <HStack spacing="35px">
          <Text>{format(new Date(), "dd/MM/yyyy")}</Text>
          <Text>{format(new Date(), "HH:mm:ss")}</Text>
        </HStack>

        <Spacer />

        <Text id="pageForPrint">Página</Text>
      </Flex>
    </Box>
  );
});
